import Checkbox from "components/atoms/Checkbox";
import H1 from "components/atoms/H1";
import Text from "components/atoms/Text";
import Layout from "components/layout";
import Breadcrumb, {
  BreadcrumbItem,
  BreadcrumbItemLink,
} from "components/molecules/Breadcrumb";
import CompareBlock from "components/molecules/CompareBlock";
import FilterCard from "components/molecules/FilterCard";
import Head from "components/molecules/Head";
import LoadingBox from "components/molecules/LoadingBox";
import Orientation from "components/molecules/Orientation";
import Pagination from "components/molecules/Pagination";
import Product from "components/molecules/Product";
import Grid, { GridCol, GridRow } from "components/organisms/Grid";
import ListProduct from "components/organisms/ListProduct";
import ProductSortResult from "components/organisms/ProductSortResult";
import Section from "components/organisms/Section";
import WrapperPanel, {
  Aside,
  MainContent,
} from "components/organisms/WrapperPanel";
import { black } from "constants/colors";
import { BASE_URL, SITE_URL } from "constants/env";
import { maxQuery, SizeMax } from "constants/media";
import { useSelector } from "hooks/useApp";
import useCompare from "hooks/useCompare";
import useWindowSize from "hooks/useWindowSize";
import React, {
  ChangeEvent,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { Helmet } from "react-helmet";
import ReactLazyLoad from "react-lazyload";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router";
import { requestFetchProductTypes } from "redux/actions/pages/productTypes";
import { requestFetchProductsByType } from "redux/actions/products/byType";
import styled, { css } from "styled-components/macro";
import { getRoomValue } from "utils/common";
import { notEmptyObject, scrollIntoRef } from "utils/utils-common";
import "./index.scss";

interface ProductsMobileSimpleProps { }

const ProductsMobileSimple: React.FC<ProductsMobileSimpleProps> = (
  props: ProductsMobileSimpleProps,
) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { width, height } = useWindowSize();
  const productPageRef = useRef<HTMLDivElement | null>(null);
  const topPosition = useMemo(() => (height < 700 ? "41%" : "50%"), [height]);
  const slug = props.match.path.replace("/danh-muc/", "");
  const [metaData, setMetaData] = useState<HeadData>();
  const pageSize = useMemo(() => (width < 576 ? 4 : 6), [width]);
  const [productSortFilters, setProductSortFilters] = useState<FilterProps>({
    slug,
    pageNum: 1,
    pageSize,
  });
  const [filters, setFilters] = useState<FilterProps | {}>({
    pageSize,
  });
  const [{ smallBanner, largeBanner }, setBanner] = useState<Banner>({
    smallBanner: "",
    largeBanner: "",
  });
  const headerDom = useMemo(() => document.getElementById("header"), []);
  const ratio = useMemo(() => (width === 1024 ? "33.69140625%" : "33.75%"), [
    width,
  ]);
  const bannerUrl = useMemo(
    () =>
      width < 576
        ? `${(smallBanner && BASE_URL) || ""}${smallBanner}`
        : `${(largeBanner && BASE_URL) || ""}${largeBanner}`,
    [largeBanner, smallBanner, width],
  );
  const [room, setRoom] = useState<CheckboxField[]>([]);
  const [loaiMay, setLoaiMay] = useState<CheckboxField[]>([]);
  const [inverter, setInverter] = useState<CheckboxField[]>([]);
  const [congSuatLamLanh, setCongSuatLamLanh] = useState<CheckboxField[]>([]);
  const [congSuatLanhSA, setCongSuatLanhSA] = useState<CheckboxField[]>([]);
  const [price, setPrice] = useState<CheckboxField[]>([]);
  const { byType } = useSelector(state => state.products);
  const { data: productTypes } = useSelector(state => state.pages.productTypes);
  const {
    compare: { data: compareList },
  } = useSelector(state => state.pages);

  const { onCompare, goToCompare } = useCompare(compareList);

  const [
    {
      loaiPhongMobile,
      inverterMobile,
      congsuatMobile,
      loaiMayMobile,
      giatienMobile,
      tinhnangMobile,
    },
    setFilterMobile,
  ] = useState<{
    loaiPhongMobile: boolean;
    loaiMayMobile: boolean;
    giatienMobile: boolean;
    inverterMobile: boolean;
    congsuatMobile: boolean;
    tinhnangMobile: boolean;
  }>({
    loaiPhongMobile: false,
    loaiMayMobile: false,
    giatienMobile: false,
    inverterMobile: false,
    congsuatMobile: false,
    tinhnangMobile: false,
  });
  const loaiPhongRef = useRef(null);
  const inverterRef = useRef(null);
  const congSuatRef = useRef(null);
  const loaiMayRef = useRef(null);
  const giaTienRef = useRef(null);
  const tinhNangRef = useRef(null);

  const isShowFilters = useMemo(() => width < 1200, [width]);

  useEffect(() => {
    if (byType && byType.data && byType.data.seo) {
      const _seo = byType.data.seo;
      if (typeof _seo === "object" && _seo.length > 0) {
        const __seo = _seo[0];
        const {
          description, // "Loại 2 dàn rời desc"
          extra_data, // "{\"image\":\"\\/storage\\/upload\\/media\\/1-2.jpg\"}"
          keywords, // "Loại 2 dàn rời keywords"
          title, // "Loại 2 dàn rời title"
        } = __seo;

        let image = "";
        try {
          const extra = JSON.parse(extra_data);
          if (extra) {
            image = extra.image;
          }
        } catch (error) { }

        setMetaData({
          image,
          keywords,
          description,
          title,
          titlePage: title,
        });
      }
    }
  }, [byType]);

  const handleRequestPage = ({ selected: page }) => {
    if (!isNaN(page)) {
      setFilters({
        ...filters,
        pageNum: page + 1,
      });
    }
  };

  useEffect(() => {
    dispatch(
      requestFetchProductsByType({
        ...filters,
        pageSize,
        slug,
      }),
    );

    setProductSortFilters({
      ...filters,
      pageSize,
      slug,
    });

    productPageRef &&
      productPageRef.current &&
      headerDom &&
      scrollIntoRef(productPageRef.current, headerDom.clientHeight);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters, pageSize]);

  useEffect(() => {
    const { homeFilter } = byType.data;

    // FILTER FROM HOME PAGE:
    if (notEmptyObject(homeFilter)) {
      Object.keys(homeFilter).forEach(k => {
        let temp;
        switch (k) {
          case "LOAI_MAY":
            temp = homeFilter[k].selected as CheckboxField[];
            setLoaiMay(temp);
            break;
          case "CONG_NGHE_INVERTER":
            temp = homeFilter[k].selected as CheckboxField[];
            setInverter(temp);
            break;
          case "CONG_SUAT_LAM_LANH":
            temp = homeFilter[k].selected as CheckboxField[];
            setCongSuatLamLanh(temp);
            break;
          case "CONG_SUAT_LANH_SA":
            temp = homeFilter[k].selected as CheckboxField[];
            setCongSuatLanhSA(temp);
            break;
          case "ROOM":
            temp = homeFilter[k].selected as CheckboxField[];
            setRoom(temp);
            break;
          case "PRICE":
            temp = homeFilter[k].selected as CheckboxField[];
            setPrice(temp);
            break;
        }
      });

      setFilters({
        ...homeFilter,
        pageSize,
      });
    } else {
      const query = new URLSearchParams(location.search);
      const _pageNum = query.get("pageNum");

      if (_pageNum) {
        setFilters({
          ...filters,
          pageNum: Number(_pageNum),
          pageSize,
        });
      } else {
        setFilters({
          ...filters,
          pageNum: 1,
          pageSize,
        });
      }
    }

    if (!productTypes) {
      dispatch(requestFetchProductTypes());
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (productTypes && !!productTypes.length) {
      let findBanner = productTypes.find(pro => pro.slug === slug);
      if (findBanner) {
        setBanner({
          smallBanner: findBanner.banner_mobile || "",
          largeBanner:
            (findBanner.meta_data && findBanner.meta_data.banner_image) || "",
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productTypes]);

  const handleChangeFilter = (e: ChangeEvent<HTMLInputElement>) => {
    const target = e.currentTarget;
    let { name, value, title, checked } = target;
    let isSettedFilters = false;

    if (name === "SORT") {
      setFilters({
        ...filters,
        [name]: value,
      });
    } else {
      // ROOM
      value = name.replace("ROOM_", "");
      let temp = room;
      const findIndex = temp.findIndex(item => item.name === name);

      if (findIndex !== -1) {
        temp.splice(findIndex, 1);
      } else {
        temp.push({
          name,
          value,
          title,
          checked: !checked,
        });
      }
      if (temp.length > 0) {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        let values = [];
        if (temp.length > 1) {
          values = [
            ...new Set(
              temp.map(item => (item.value === "1" ? item.value : "2")),
            ),
          ];
        }

        setFilters({
          ...filters,
          ROOM: {
            selected: temp,
            value: getRoomValue(temp),
          },
        });
      } else {
        delete filters.ROOM;
        setFilters({ ...filters });
      }
      setRoom(temp);
      isSettedFilters = true;

      // LOAI_MAY
      if (name.includes("LOAI_MAY_")) {
        value = name.replace("LOAI_MAY_", "");
        let temp = loaiMay as CheckboxField[];
        const findIndex = temp.findIndex(item => item.name === name);

        if (findIndex !== -1) {
          temp.splice(findIndex, 1);
        } else {
          temp.push({
            name,
            value,
            title,
            checked: !checked,
          });
        }
        if (temp.length > 0) {
          setFilters({
            ...filters,
            LOAI_MAY: {
              selected: temp,
              value:
                temp.length > 1
                  ? temp.map(item => item.value).join(",")
                  : temp[0].value,
            },
          });
        } else {
          delete filters["LOAI_MAY"];
          setFilters({ ...filters });
        }

        setLoaiMay(temp);
        isSettedFilters = true;
      }

      // CONG_NGHE_INVERTER
      if (name.includes("CONG_NGHE_INVERTER_")) {
        value = name.replace("CONG_NGHE_INVERTER_", "");
        const temp = inverter;

        const findIndex = temp.findIndex(item => item.name === name);
        if (findIndex !== -1) {
          temp.splice(findIndex, 1);
        } else {
          temp.push({
            name,
            value,
            title,
            checked: !checked,
          });
        }
        if (temp.length > 0) {
          setFilters({
            ...filters,
            CONG_NGHE_INVERTER: {
              selected: temp,
              value:
                temp.length > 1
                  ? temp.map(item => item.value).join(",")
                  : temp[0].value,
            },
          });
        } else {
          delete filters.CONG_NGHE_INVERTER;
          setFilters({ ...filters });
        }

        setInverter(temp);
        isSettedFilters = true;
      }

      // CONG_SUAT_LAM_LANH
      if (name.includes("CONG_SUAT_LAM_LANH_")) {
        value = name.replace("CONG_SUAT_LAM_LANH_", "");
        const temp = congSuatLamLanh;

        const findIndex = temp.findIndex(item => item.name === name);
        if (findIndex !== -1) {
          temp.splice(findIndex, 1);
        } else {
          temp.push({
            name,
            value,
            title,
            checked: !checked,
          });
        }
        if (temp.length > 0) {
          setFilters({
            ...filters,
            CONG_SUAT_LAM_LANH: {
              selected: temp,
              value:
                temp.length > 1
                  ? temp.map(item => item.value).join(",")
                  : temp[0].value,
            },
          });
        } else {
          delete filters.CONG_SUAT_LAM_LANH;
          setFilters({ ...filters });
        }

        setCongSuatLamLanh(temp);
        isSettedFilters = true;
      }

      // CONG_SUAT_LANH_SA
      if (name.includes("CONG_SUAT_LANH_SA_")) {
        value = name.replace("CONG_SUAT_LANH_SA_", "");
        const temp = congSuatLanhSA;

        const findIndex = temp.findIndex(item => item.name === name);
        if (findIndex !== -1) {
          temp.splice(findIndex, 1);
        } else {
          temp.push({
            name,
            value,
            title,
            checked: !checked,
          });
        }
        if (temp.length > 0) {
          setFilters({
            ...filters,
            CONG_SUAT_LANH_SA: {
              selected: temp,
              value:
                temp.length > 1
                  ? temp.map(item => item.value).join(",")
                  : temp[0].value,
            },
          });
        } else {
          delete filters.CONG_SUAT_LANH_SA;
          setFilters({ ...filters });
        }

        setCongSuatLanhSA(temp);
        isSettedFilters = true;
      }

      // PRICE
      if (name.includes("PRICE_")) {
        value = name.replace("PRICE_", "");
        const temp = price;

        const findIndex = temp.findIndex(item => item.name === name);
        if (findIndex !== -1) {
          temp.splice(findIndex, 1);
        } else {
          temp.push({
            name,
            value,
            title,
            checked: !checked,
          });
        }
        if (temp.length > 0) {
          setFilters({
            ...filters,
            PRICE: {
              selected: temp,
              value:
                temp.length > 1
                  ? temp.map(item => item.value).join(",")
                  : temp[0].value,
            },
          });
        } else {
          delete filters.PRICE;
          setFilters({ ...filters });
        }

        setPrice(temp);
        isSettedFilters = true;
      }

      // TINH NANG CHINH
      if (
        name.includes("CAN_BANG_DO_AM_THONG_MINH") ||
        name.includes("LUONG_GIO_3_CHIEU") ||
        name.includes("TIET_KIEM_NANG_LUONG") ||
        name.includes("LAM_LANH_NHANH") ||
        name.includes("TINH_LOC_KHONG_KHI") ||
        name.includes("LUONG_GIO_COANDA") ||
        name.includes("CHUC_NANG_CHONG_AM_MOC") ||
        name.includes("DO_BEN_CAO") ||
        name.includes("DIEU_KHIEN_TIEN_NGHI")
      ) {
        if (!checked) {
          delete filters[name as KeyFilter];
          setFilters({ ...filters });
        } else {
          setFilters({
            ...filters,
            [name]: {
              title,
              checked,
            },
          });
        }

        isSettedFilters = true;
      }

      // This filtering already set change on radio input. Pushing it into filters.
      !isSettedFilters &&
        setFilters({
          ...filters,
          [name]: value,
        });
    }
  };

  const handleRemoveFilter = (key: KeyFilter, title?: string) => {
    const { selected } = filters[key] as {
      selected: CheckboxField[];
      value: string;
    };

    if (title && selected) {
      selected.forEach((x, i) => {
        if (x.title === title) {
          selected.splice(i, 1);
          setFilters({
            ...filters,
            [key]: {
              value:
                selected.map(item => item.value).join(",") || itemEdit.value,
              selected,
            },
          });
        }
      });
    } else {
      delete filters[key];
      setFilters({ ...filters });
    }

    switch (key) {
      case "ROOM":
        if (room.toString() === "") setRoom([]);
        else setRoom((filters.ROOM && filters.ROOM.selected) || []);
        break;
      case "LOAI_MAY":
        if (loaiMay.toString() === "") setLoaiMay([]);
        else setLoaiMay((filters.LOAI_MAY && filters.LOAI_MAY.selected) || []);
        break;
      case "CONG_NGHE_INVERTER":
        if (inverter.toString() === "") setInverter([]);
        else
          setInverter(
            (filters.CONG_NGHE_INVERTER &&
              filters.CONG_NGHE_INVERTER.selected) ||
            [],
          );
        break;
      case "CONG_SUAT_LAM_LANH":
        if (congSuatLamLanh.toString() === "") setCongSuatLamLanh([]);
        else
          setCongSuatLamLanh(
            (filters.CONG_SUAT_LAM_LANH &&
              filters.CONG_SUAT_LAM_LANH.selected) ||
            [],
          );
        break;
      case "CONG_SUAT_LANH_SA":
        if (congSuatLanhSA.toString() === "") setCongSuatLanhSA([]);
        else
          setCongSuatLanhSA(
            (filters.CONG_SUAT_LANH_SA && filters.CONG_SUAT_LANH_SA.selected) ||
            [],
          );
        break;
      case "PRICE":
        if (price.toString() === "") setPrice([]);
        else setPrice((filters.PRICE && filters.PRICE.selected) || []);
        break;
    }
  };

  const handleRemoveAllFilter = () => {
    for (const key in filters) {
      const k = key as KeyFilter;
      if (k === "slug" || k === "pageSize" || k === "pageNum") continue;
      else delete filters[k];
    }
    setFilters({ ...filters });
    setRoom([]);
    setLoaiMay([]);
    setInverter([]);
    setCongSuatLamLanh([]);
    setCongSuatLanhSA([]);
    setPrice([]);
  };

  const {
    split: { products, totalRecords, totalPages, loading: productDataLoading },
  } = byType.data;

  const handleHasCBLabel = useCallback(
    products &&
    products.some(
      (item: any) =>
        item.cashback_text !== null || item.cashback_img !== null,
    ),
    [products],
  );

  return (
    <Container>
      <Head data={metaData} />
      <Helmet>
        <link rel="canonical" href={`${SITE_URL}/danh-muc/${slug}`} />
      </Helmet>
      {bannerUrl && (
        <>
          <div
            className="category-banner"
            style={{
              background: `url("${bannerUrl}") no-repeat center 100% / cover`,
              paddingBottom: `${ratio}`,
            }}
            title="Banner Điều hoà dân dụng - Loại hai dàn rời"
          />
          <img className="category-banner-mobile" alt="Banner Điều hoà dân dụng - Loại hai dàn rời" src={bannerUrl} />
        </>
      )}
      <div ref={productPageRef}>
        <Breadcrumb>
          <BreadcrumbItemLink href="/">Trang chủ</BreadcrumbItemLink>
          <BreadcrumbItemLink href={`/danh-muc/${slug}`}>
            Sản phẩm
          </BreadcrumbItemLink>
          <BreadcrumbItem>Điều hoà dân dụng - Loại hai dàn rời</BreadcrumbItem>
        </Breadcrumb>
      </div>
      <Section modifiers={["gray"]}>
        <Grid>
          <div className="p-products">
            <WrapperPanel modifiers={["aside-sm"]}>
              <Aside
                className="wrapper-filter-products"
                asideClassName="aside-filters"
                isShowFilter={isShowFilters}
              >
                {/* Loại phòng */}
                <FilterCard
                  title="Loại phòng"
                  originalPosition="left"
                  ref={loaiPhongRef}
                  showContent={loaiPhongMobile}
                  handleShowContent={() =>
                    setFilterMobile(filterMobiles => ({
                      ...filterMobiles,
                      loaiPhongMobile: !loaiPhongMobile,
                    }))
                  }
                >
                  <Orientation modifiers={["vertical"]}>
                    <Checkbox
                      type="checkbox"
                      name="ROOM_1"
                      value="2"
                      display="Phòng Khách"
                      title="Phòng Khách"
                      checked={
                        room.filter(item => item.name === "ROOM_1").length > 0
                      }
                      onChange={handleChangeFilter}
                    />

                    <Checkbox
                      type="checkbox"
                      name="ROOM_2"
                      value="1"
                      display="Phòng Ngủ"
                      title="Phòng Ngủ"
                      checked={
                        room.filter(item => item.name === "ROOM_2").length > 0
                      }
                      onChange={handleChangeFilter}
                    />

                    <Checkbox
                      type="checkbox"
                      name="ROOM_3"
                      value="3"
                      display="Phòng Trẻ Em"
                      title="Phòng Trẻ Em"
                      checked={
                        room.filter(item => item.name === "ROOM_3").length > 0
                      }
                      onChange={handleChangeFilter}
                    />

                    <Checkbox
                      type="checkbox"
                      name="ROOM_4"
                      value="4"
                      display="Phòng Học"
                      title="Phòng Học"
                      checked={
                        room.filter(item => item.name === "ROOM_4").length > 0
                      }
                      onChange={handleChangeFilter}
                    />
                  </Orientation>
                </FilterCard>
                {/* Loại Máy */}
                <FilterCard
                  title="Loại Máy"
                  originalPosition="left"
                  ref={loaiMayRef}
                  showContent={loaiMayMobile}
                  handleShowContent={() =>
                    setFilterMobile(filterMobiles => ({
                      ...filterMobiles,
                      loaiMayMobile: !loaiMayMobile,
                    }))
                  }
                >
                  <Orientation modifiers={["vertical"]}>
                    <Checkbox
                      type="checkbox"
                      name="LOAI_MAY_CO"
                      value="CO"
                      display="1 Chiều Lạnh"
                      title="1 Chiều Lạnh"
                      checked={
                        loaiMay.filter(item => item.name === "LOAI_MAY_CO")
                          .length > 0
                      }
                      onChange={handleChangeFilter}
                    />
                    <Checkbox
                      type="checkbox"
                      name="LOAI_MAY_HP"
                      value="HP"
                      display="2 Chiều Lạnh - Sưởi"
                      title="2 Chiều Lạnh - Sưởi"
                      checked={
                        loaiMay.filter(item => item.name === "LOAI_MAY_HP")
                          .length > 0
                      }
                      onChange={handleChangeFilter}
                    />
                  </Orientation>
                </FilterCard>
                {/* Inverter/Tiết Kiệm Điện */}
                <FilterCard
                  title={isShowFilters ? "Inverter" : "Inverter/Tiết Kiệm Điện"}
                  originalPosition="right"
                  ref={inverterRef}
                  showContent={inverterMobile}
                  handleShowContent={() =>
                    setFilterMobile(filterMobiles => ({
                      ...filterMobiles,
                      inverterMobile: !inverterMobile,
                    }))
                  }
                >
                  <Orientation modifiers={["vertical"]}>
                    <Checkbox
                      type="checkbox"
                      name="CONG_NGHE_INVERTER_1"
                      value="1"
                      display="Có Inverter"
                      title="Có Inverter"
                      checked={
                        inverter.filter(
                          item => item.name === "CONG_NGHE_INVERTER_1",
                        ).length > 0
                      }
                      onChange={handleChangeFilter}
                    />
                    <Checkbox
                      type="checkbox"
                      name="CONG_NGHE_INVERTER_0"
                      value="0"
                      display="Không Inverter"
                      title="Không Inverter"
                      checked={
                        inverter.filter(
                          item => item.name === "CONG_NGHE_INVERTER_0",
                        ).length > 0
                      }
                      onChange={handleChangeFilter}
                    />
                  </Orientation>
                </FilterCard>
                {/* Công suất làm lạnh */}
                <FilterCard
                  title={isShowFilters ? "Công suất" : "Công suất làm lạnh"}
                  tooltipIcon={"info-cyan"}
                  originalPosition="left"
                  className="product-filter-tooltip"
                  ref={congSuatRef}
                  showContent={congsuatMobile}
                  handleShowContent={() =>
                    setFilterMobile(filterMobiles => ({
                      ...filterMobiles,
                      congsuatMobile: !congsuatMobile,
                    }))
                  }
                >
                  <Orientation modifiers={["aside-product", "full-width"]}>
                    <Checkbox
                      name="CONG_SUAT_LAM_LANH_1"
                      type="checkbox"
                      value="1"
                      display={`<span>
                                1HP
                                <span>
                                  Phòng
                                  <br />
                                  &lt;12m<sup>2</sup>
                                </span>
                              </span>`}
                      title="1HP"
                      icon="air-2"
                      modifier={["vertical", "no-spacing"]}
                      checked={
                        congSuatLamLanh.filter(
                          item => item.name === "CONG_SUAT_LAM_LANH_1",
                        ).length > 0
                      }
                      onChange={handleChangeFilter}
                    />
                    <Checkbox
                      name="CONG_SUAT_LAM_LANH_1.5"
                      type="checkbox"
                      value="1.5"
                      display={`
                              <span>
                                1.5HP
                                <span>
                                  13m<sup>2</sup>
                                  <br />
                                  -18m<sup>2</sup>
                                </span>
                              </span>
                            `}
                      title="1.5HP"
                      icon="air-3"
                      modifier={["vertical", "no-spacing"]}
                      checked={
                        congSuatLamLanh.filter(
                          item => item.name === "CONG_SUAT_LAM_LANH_1.5",
                        ).length > 0
                      }
                      onChange={handleChangeFilter}
                    />
                    <Checkbox
                      name="CONG_SUAT_LAM_LANH_2"
                      type="checkbox"
                      value="2"
                      display={`
                              <span>
                                2HP
                                <span>
                                  19m<sup>2</sup>
                                  <br />
                                  -27m<sup>2</sup>
                                </span>
                              </span>
                            `}
                      title="2HP"
                      icon="air-4"
                      modifier={["vertical", "no-spacing"]}
                      checked={
                        congSuatLamLanh.filter(
                          item => item.name === "CONG_SUAT_LAM_LANH_2",
                        ).length > 0
                      }
                      onChange={handleChangeFilter}
                    />
                    <Checkbox
                      name="CONG_SUAT_LAM_LANH_2.5"
                      type="checkbox"
                      value="2.5"
                      display={`
                              <span>
                                2.5HP
                                <span>
                                  28m<sup>2</sup>
                                  <br />
                                  -33m<sup>2</sup>
                                </span>
                              </span>
                            `}
                      title="2.5HP"
                      icon="air-5"
                      modifier={["vertical", "no-spacing"]}
                      checked={
                        congSuatLamLanh.filter(
                          item => item.name === "CONG_SUAT_LAM_LANH_2.5",
                        ).length > 0
                      }
                      onChange={handleChangeFilter}
                    />
                    <Checkbox
                      name="CONG_SUAT_LAM_LANH_3"
                      type="checkbox"
                      value="3"
                      display={`
                              <span>
                                3HP
                                <span>
                                  34m<sup>2</sup>
                                  <br />
                                  -40m<sup>2</sup>
                                </span>
                              </span>
                            `}
                      title="3HP"
                      icon="air-6"
                      modifier={["vertical", "no-spacing"]}
                      checked={
                        congSuatLamLanh.filter(
                          item => item.name === "CONG_SUAT_LAM_LANH_3",
                        ).length > 0
                      }
                      onChange={handleChangeFilter}
                    />
                  </Orientation>
                </FilterCard>
                {/* Giá tiền */}
                <FilterCard
                  title="Giá tiền"
                  originalPosition="left"
                  ref={giaTienRef}
                  showContent={giatienMobile}
                  handleShowContent={() =>
                    setFilterMobile(filterMobiles => ({
                      ...filterMobiles,
                      giatienMobile: !giatienMobile,
                    }))
                  }
                >
                  <Orientation modifiers={["vertical"]}>
                    <Checkbox
                      name="PRICE_1"
                      type="checkbox"
                      value="1"
                      display="Dưới 8.000.000₫"
                      title="Dưới 8.000.000₫"
                      checked={
                        price.filter(item => item.name === "PRICE_1").length > 0
                      }
                      onChange={handleChangeFilter}
                    />
                    <Checkbox
                      type="checkbox"
                      name="PRICE_2"
                      value="2"
                      display="8.000.000₫ - 12.000.000₫"
                      title="8.000.000₫ - 12.000.000₫"
                      checked={
                        price.filter(item => item.name === "PRICE_2").length > 0
                      }
                      onChange={handleChangeFilter}
                    />
                    <Checkbox
                      type="checkbox"
                      name="PRICE_3"
                      value="3"
                      display="12.000.000₫ - 15.000.000₫"
                      title="12.000.000₫ - 15.000.000₫"
                      checked={
                        price.filter(item => item.name === "PRICE_3").length > 0
                      }
                      onChange={handleChangeFilter}
                    />
                    <Checkbox
                      type="checkbox"
                      name="PRICE_4"
                      value="4"
                      display="Trên 15.000.000₫"
                      title="Trên 15.000.000₫"
                      checked={
                        price.filter(item => item.name === "PRICE_4").length > 0
                      }
                      onChange={handleChangeFilter}
                    />
                  </Orientation>
                </FilterCard>
                {/* tính năng chính */}
                <FilterCard
                  title={isShowFilters ? "tính năng" : "tính năng chính"}
                  originalPosition="right"
                  ref={tinhNangRef}
                  showContent={tinhnangMobile}
                  handleShowContent={() =>
                    setFilterMobile(filterMobiles => ({
                      ...filterMobiles,
                      tinhnangMobile: !tinhnangMobile,
                    }))
                  }
                >
                  <Orientation modifiers={["vertical"]}>
                    <Checkbox
                      type="checkbox"
                      name="CAN_BANG_DO_AM_THONG_MINH"
                      value={filters.CAN_BANG_DO_AM_THONG_MINH ? "1" : "0"}
                      display="Cân Bằng Độ Ẩm Thông Minh"
                      title="Cân Bằng Độ Ẩm Thông Minh"
                      checked={
                        filters.CAN_BANG_DO_AM_THONG_MINH &&
                        filters.CAN_BANG_DO_AM_THONG_MINH.checked
                      }
                      onChange={handleChangeFilter}
                    />
                    <Checkbox
                      type="checkbox"
                      name="LUONG_GIO_3_CHIEU"
                      value={filters.LUONG_GIO_3_CHIEU ? "1" : "0"}
                      display="Luồng Gió 3 Chiều"
                      title="Luồng Gió 3 Chiều"
                      checked={
                        filters.LUONG_GIO_3_CHIEU &&
                        filters.LUONG_GIO_3_CHIEU.checked
                      }
                      onChange={handleChangeFilter}
                    />
                    <Checkbox
                      type="checkbox"
                      name="LAM_LANH_NHANH"
                      value={filters.LAM_LANH_NHANH ? "1" : "0"}
                      display="Làm Lạnh Nhanh"
                      title="Làm Lạnh Nhanh"
                      checked={
                        filters.LAM_LANH_NHANH && filters.LAM_LANH_NHANH.checked
                      }
                      onChange={handleChangeFilter}
                    />
                    <Checkbox
                      type="checkbox"
                      name="TIET_KIEM_NANG_LUONG"
                      value={filters.TIET_KIEM_NANG_LUONG ? "1" : "0"}
                      display="Tiết Kiệm Năng Lượng"
                      title="Tiết Kiệm Năng Lượng"
                      checked={
                        filters.TIET_KIEM_NANG_LUONG &&
                        filters.TIET_KIEM_NANG_LUONG.checked
                      }
                      onChange={handleChangeFilter}
                    />
                    <Checkbox
                      type="checkbox"
                      name="TINH_LOC_KHONG_KHI"
                      value={filters.TINH_LOC_KHONG_KHI ? "1" : "0"}
                      display="Lọc Không Khí"
                      title="Lọc Không Khí"
                      checked={
                        filters.TINH_LOC_KHONG_KHI &&
                        filters.TINH_LOC_KHONG_KHI.checked
                      }
                      onChange={handleChangeFilter}
                    />
                    <Checkbox
                      type="checkbox"
                      name="LUONG_GIO_COANDA"
                      value={filters.LUONG_GIO_COANDA ? "1" : "0"}
                      display="Luồng Gió Coanda"
                      title="Luồng Gió Coanda"
                      checked={
                        filters.LUONG_GIO_COANDA &&
                        filters.LUONG_GIO_COANDA.checked
                      }
                      onChange={handleChangeFilter}
                    />
                    <Checkbox
                      type="checkbox"
                      name="CHUC_NANG_CHONG_AM_MOC"
                      value={filters.CHUC_NANG_CHONG_AM_MOC ? "1" : "0"}
                      display="Chức Năng Chống Ẩm Mốc"
                      title="Chức Năng Chống Ẩm Mốc"
                      checked={
                        filters.CHUC_NANG_CHONG_AM_MOC &&
                        filters.CHUC_NANG_CHONG_AM_MOC.checked
                      }
                      onChange={handleChangeFilter}
                    />
                    <Checkbox
                      type="checkbox"
                      name="DO_BEN_CAO"
                      value={filters.DO_BEN_CAO ? "1" : "0"}
                      display="Độ Bền Cao"
                      title="Độ Bền Cao"
                      checked={filters.DO_BEN_CAO && filters.DO_BEN_CAO.checked}
                      onChange={handleChangeFilter}
                    />
                    <Checkbox
                      type="checkbox"
                      name="DIEU_KHIEN_TIEN_NGHI"
                      value={filters.DIEU_KHIEN_TIEN_NGHI ? "1" : "0"}
                      display="Điều Khiển Tiện Nghi"
                      title="Điều Khiển Tiện Nghi"
                      checked={
                        filters.DIEU_KHIEN_TIEN_NGHI &&
                        filters.DIEU_KHIEN_TIEN_NGHI.checked
                      }
                      onChange={handleChangeFilter}
                    />
                  </Orientation>
                </FilterCard>
              </Aside>
              <MainContent>
                <ProductSortResult
                  filters={productSortFilters}
                  count={products ? products.length : 0}
                  isShowSortFilter={true}
                  total={!!products ? totalRecords : 0}
                  handleChange={handleChangeFilter}
                  handleRemoveFilter={handleRemoveFilter}
                  handleRemoveAllFilter={handleRemoveAllFilter}
                />
                <ListProduct>
                  {
                    // Bổ sung H1 không hiển thị:
                  }
                  <H1>Điều hoà dân dụng - Loại hai dàn rời</H1>
                  {productDataLoading && (
                    <LoadingBox label="Đang tải dữ liệu..." />
                  )}
                  {products && !!products.length ? (
                    <ReactLazyLoad>
                      <GridRow>
                        {products.map((product: any, index: number) => (
                          <GridCol key={index} colLg={4} colMd={6} colSm={6}>
                            <Product
                              product={product}
                              addToCardButton={true}
                              onCompare={onCompare}
                              trademarks={
                                product.trademarks &&
                                  product.trademarks.length > 0
                                  ? product.trademarks.map(
                                    (tra: any) => tra.name,
                                  )
                                  : []
                              }
                              tags={
                                product.tags && !!product.tags.length
                                  ? product.tags.map(
                                    (tag: any, index2: number) => (
                                      <div
                                        key={index2}
                                        className="m-product_trademark_item service"
                                      >
                                        <Text
                                          modifiers={["primary"]}
                                          size="sm"
                                        >
                                          {tag.name}
                                        </Text>
                                      </div>
                                    ),
                                  )
                                  : []
                              }
                              hasCashbackLabel={handleHasCBLabel}
                            />
                          </GridCol>
                        ))}
                      </GridRow>
                    </ReactLazyLoad>
                  ) : (
                    <Text className="p3" modifiers={["center"]} weight="bold">
                      Không có sản phẩm
                    </Text>
                  )}
                  {compareList.length > 0 && (
                    <div onClick={goToCompare}>
                      <CompareBlock
                        count={compareList.length}
                        topPosition={topPosition}
                      />
                    </div>
                  )}
                </ListProduct>
                <ReactLazyLoad>
                  {totalPages > 1 && (
                    <Pagination
                      initialPage={Number((filters as FilterProps).pageNum) - 1}
                      limit={pageSize}
                      totalCount={totalRecords}
                      handlePageClick={handleRequestPage}
                    />
                  )}
                </ReactLazyLoad>
              </MainContent>
            </WrapperPanel>
          </div>
        </Grid>
      </Section>
    </Container>
  );
};

const Container = styled(Layout)`
  .category-banner {
    display: block;
  }
  .p-products {
    .o-wrapper-panel-aside {
      .a-checkbox_text {
        .a-text-primary {
          span {
            color: ${black};
            max-width: 50px;
            display: inherit;
          }
        }
      }

      &.wrapper-filter-products {
        ${maxQuery(
  SizeMax.ExtraLarge,
  css`
            .aside-filters {
              display: flex;
              flex-wrap: wrap;
            }

            .product-filter-tooltip {
              .m-productfeature {
                display: none;
              }
            }
          `,
)}

        ${maxQuery(
  SizeMax.Medium,
  css`
            .aside-filters {
              justify-content: space-between;
            }

            .m-filtercard {
              width: calc((100% / 3) - 0.25em);
            }
          `,
)}
      }
    }
  }
`;

export default ProductsMobileSimple;
